import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SimpleModal from "../../../components/common/SimpleModal";
import UploadMessageImage from "./UploadMessageImage";
import SendMessageButton from "./UploadImageButton";
import { onChangeMessage } from "../redux/chatSlice";
import { ImageIcon, SendIcon } from "../../../constants/icon_path";

const ChatInput = ({ sendMessage }) => {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const dispatch = useDispatch();
  const chat = useSelector((state) => state.chat);
  const { message, currentChat, isImage } = chat;

  const handleSubmit = (e) => {
    e.preventDefault();
    sendMessage({
      variables: {
        input: {
          member: currentChat?.memberId,
          message,
          isAdmin: true,
          isImage,
        },
      },
    });
  };

  const handleChangeMessage = (message) => {
    dispatch(onChangeMessage(message));
  };

  const handleClickImage = () => setShowModal(true);

  return (
    <div className="chat_input lao">
      <SimpleModal
        show={showModal}
        handleClose={handleCloseModal}
        size="md"
        title={
          <SendMessageButton
            message={message}
            handleClose={handleCloseModal}
            sendMessage={sendMessage}
          />
        }
      >
        <UploadMessageImage />
      </SimpleModal>
      <Row>
        <Col xs="2" md="1">
          <div className="image m-2">
            <ImageIcon onClick={handleClickImage} size={25} color="grey" />
          </div>
        </Col>
        <Col xs="10" md="11" className="p-2">
          <Form
            onSubmit={handleSubmit}
            className="d-flex justify-content-between"
          >
            <Form.Control
              type="text"
              placeholder="ປ້ອນຂໍ້ຄວາມ"
              size="sm"
              onChange={(e) => handleChangeMessage(e.target.value)}
              value={message}
            />
            <Button
              type="submit"
              style={{ marginLeft: "10px", marginRight: "10px" }}
              disabled={!message}
            >
              <SendIcon size={20} />
            </Button>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default ChatInput;
